<template>
    <section
        id="demo"
        class="border-y border-slate-200 bg-white py-24"
        aria-labelledby="demo-heading"
    >
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div class="mx-auto max-w-5xl space-y-8 text-center">
                <div class="space-y-3">
                    <p
                        class="text-primary text-xs font-bold uppercase tracking-wide"
                    >
                        Quick Demo
                    </p>
                    <h2
                        id="demo-heading"
                        class="text-3xl font-bold tracking-tight sm:text-4xl"
                    >
                        See it in action
                    </h2>
                    <p class="mx-auto max-w-2xl text-slate-600">
                        See how easy it is for your clients to book a meeting
                        with you.
                    </p>
                </div>

                <figure
                    class="overflow-hidden rounded-xl border border-slate-200"
                >
                    <video
                        class="block w-full md:hidden"
                        aria-label="TinyCal mobile booking demo"
                        autoplay
                        loop
                        muted
                        playsinline
                        controls
                        preload="none"
                        poster="https://cdn.tinycal.net/assets/website/demo-mobile-20260317-190438.png"
                    >
                        <source
                            src="https://cdn.tinycal.net/assets/website/demo-mobile-20260317-190438.mp4"
                            type="video/mp4"
                        />
                    </video>

                    <video
                        class="hidden w-full md:block"
                        aria-label="TinyCal desktop booking demo"
                        autoplay
                        loop
                        muted
                        playsinline
                        controls
                        preload="none"
                        poster="https://cdn.tinycal.net/assets/website/demo-web-20260317-190438.png"
                    >
                        <source
                            src="https://cdn.tinycal.net/assets/website/demo-web-20260317-190438.mp4"
                            type="video/mp4"
                        />
                    </video>
                </figure>
            </div>
        </div>
    </section>
</template>
